<template>
  <div>
    <v-card class="mt-5">
      <v-card-text>
        <div v-if="!biddedRfqs.length" class="text-center">
          <strong>No Quotes found...</strong>
        </div>
        <div v-for="rfq in biddedRfqs" :key="rfq.id">
          <v-hover v-slot="{ hover }">
            <v-card :elevation="hover ? 12 : 0" class="px-2 cursor-pointer">
              <v-row align-md="center">
                <v-col cols="12" md="8" lg="9">
                  <div class="d-flex align-center">
                    <div>
                      <v-img
                        width="80"
                        height="60"
                        :src="require(`@/assets/images/BMC.png`)"
                        contain
                      ></v-img>
                    </div>
                    <div class="ml-1">
                      <h6 class="primary--text pb-0 mb-0">
                        <strong>{{ rfq.dealer.company }}</strong>
                      </h6>
                      <div>
                        <strong>Phone: </strong>
                        <span>{{ rfq.dealer.phone }} </span>
                      </div>
                      <div>
                        <strong>Address: </strong>
                        <span v-if="rfq.dealer.address.add_line_1"
                          >{{ rfq.dealer.address.add_line_1 }},
                        </span>
                        <span v-if="rfq.dealer.address.add_line_2"
                          >{{ rfq.dealer.address.add_line_2 }},
                        </span>
                        <span v-if="rfq.dealer.address.add_line_3"
                          >{{ rfq.dealer.address.add_line_3 }}
                        </span>
                      </div>
                    </div>
                  </div>
                </v-col>
                <v-col cols="12" md="4" lg="3" class="text-right text-md-left">
                  <template v-if="getLastBid(rfq.bids)">
                    <div class="grey--text">
                      Received:
                      {{
                        new Date(getLastBid(rfq.bids).sent_on).toLocaleString()
                      }}
                    </div>
                    <h6>Last Bid: ${{ getLastBid(rfq.bids).bid_amount }}</h6>
                    <h6>
                      Est Delivery:
                      {{ getLastBid(rfq.bids).bid_delivery_time }}
                    </h6>
                    <v-btn
                      depressed
                      color="primary"
                      class="white--text"
                      @click="viewQuote(rfq)"
                      ><v-icon color="white" size="18" class="mr-1"
                        >mdi-email-fast</v-icon
                      >
                      View Quote</v-btn
                    >
                  </template>
                </v-col>
              </v-row>
            </v-card>
          </v-hover>
          <v-divider></v-divider>
        </div>
      </v-card-text>
    </v-card>

    <Quotes
      v-if="quotesModal && quote"
      :quote="quote"
      :dialog="quotesModal"
      :schedule="schedule"
      @refresh="loadRFQs"
      @close="quotesModal = false"
    />
  </div>
</template>

<script>
import Quotes from "@/components/rfq/Quotes";
import states from "@/configs/states.json";
import { mapState } from "vuex";
export default {
  components: {
    Quotes
  },
  props: {
    schedule: {
      type: Object,
      default: null
    }
  },
  computed: {
    ...mapState({
      projectRfqs: state => state.rfq.project_rfqs
    }),

    biddedRfqs() {
      if (this.projectRfqs && this.projectRfqs.length > 0) {
        return this.projectRfqs.filter(rfq => rfq.bids.length > 0);
      }

      return [];
    }
  },
  methods: {
    getLastBid(bids) {
      if (Array.isArray(bids) && bids.length > 0) {
        return bids.at(-1);
      }
      return null;
    },
    viewQuote(rfq) {
      this.quote = { ...rfq };
      this.quotesModal = true;
    },
    async loadRFQs() {
      this.quotesModal = false;
      const payload = {
        project_id: this.$route.params.id,
        schedule: this.$route.params.name
      };

      this.$store.dispatch("rfq/getProjectRFQs", payload);
    }
  },
  data() {
    return {
      states,
      requestModal: false,
      sentModal: false,
      quotesModal: false,
      quote: null,
      dealers: [
        {
          id: 1,
          name: "Black canyon window and door",
          phone: "970-252-3547",
          address: "336 East Main St. Montrose, CO 81401",
          image: "Black Canyon",
          status: "received"
        },
        {
          id: 2,
          name: "BMC",
          phone: "435-649-8477",
          address: "1185 West Lori Lane Kamas, UT 84036",
          image: "BMC",
          status: "received"
        }
      ]
    };
  }
};
</script>
